import { createContext, useContext, useEffect, useReducer } from "react";
import { LOADING_END, LOADING_START } from "../actions/ui.action";
import UIReducer from "../reducers/UIReducer";

const initialState = {
  loading: true,
};

const UI = createContext(initialState);

export const UIProvider = ({ children }) => {
  const [state, dispatch] = useReducer(UIReducer, initialState);

  const loadingStart = () => dispatch({ type: LOADING_START });
  const loadingEnd = () => dispatch({ type: LOADING_END });
  return (
    <UI.Provider value={{ ...state, loadingEnd, loadingStart }}>
      {children}
    </UI.Provider>
  );
};

export const useUIContext = () => useContext(UI);
